module.exports = __webpack_public_path__ + "img/dabiao_0003_4.8951a6e6.png";